<template>
  <router-view></router-view>
</template>

<script>
export default {
  	name: 'App',
  	watch: {
	    $route: {
	        immediate: true,
	        handler(to, from) {
	            document.title = this.$t(to.name) + " - Goal Traders" || 'Goal Traders';
	        }
	    },
	}
}
</script>


<!--testing-->
<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
